import React from "react";
import { RaisedButton, FlatButton, FontIcon } from "material-ui";
import { formatPrice } from "../util";
import StatsBlockContainer from "./partials/stats-block-container.jsx";
import StatsBlock from "./partials/stats-block.jsx";
import EventBucketSalesChart from "./partials/event-bucket-sales-chart.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import Chart from "./partials/charts/chart.jsx";
import TableRefreshIndicator from "./partials/table-refresh-indicator.jsx";
import ViewLiveVirtualButton from "./partials/view-live-virtual-button.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketActions from "../actions/EventBucketActions";
import EventBucketStore from "../stores/EventBucketStore";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";
import UserStore from "../stores/UserStore";

class EventBucket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetchingEventBucket: false,
      fetchedEventBucket: null,
      showAllTime: false
    };

    this._refresh = this._refresh.bind(this);
  }

  static getStores() {
    return [EventBucketStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    return {
      isFetching: EventBucketStore.getState().isFetching,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getEventBucketOverview: AnalyticsStore.getEventBucketOverview
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      title: {
        textAlign: "center"
      },
      actionButtonsContainer: {
        textAlign: "center",
        marginTop: "1em"
      }
    };
  }

  _refresh(props) {
    this.setState({ isFetchingEventBucket: true }, () => {
      EventBucketActions.fetchOne((props || this.props).params.eventBucketId);
      AnalyticsActions.fetchEventBucketOverview(
        (props || this.props).params.eventBucketId
      );
    });
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var eventBucket = newProps.getEventBucketById(
      newProps.params.eventBucketId
    );

    if (
      !this.state.isFetchingEventBucket &&
      this.state.fetchedEventBucket !== newProps.params.eventBucketId
    ) {
      this._refresh(newProps);
    } else if (eventBucket) {
      this.setState({
        isFetchingEventBucket: false,
        fetchedEventBucket: eventBucket.id
      });
    }
  }

  render() {
    var styles = this.getStyles(),
      eventBucket = this.props.getEventBucketById(
        this.props.params.eventBucketId
      ),
      overview = this.props.getEventBucketOverview(
        this.props.params.eventBucketId
      );

    function count(key, amount) {
      return `${amount} ${key + (amount !== 1 ? "s" : "")}`;
    }

    if (!eventBucket) {
      return <WorkingIndicator fullPage={true} />;
    }

    const hasBanner = eventBucket.frontend_config.banner_image;

    return (
      <div>
        {(!UserStore.hasRole("box_office") || !hasBanner) && (
          <h1 style={styles.title}>{eventBucket.name}</h1>
        )}
        <div style={styles.actionButtonsContainer}>
          {UserStore.hasRole("box_office") ? (
            hasBanner && (
              <img
                src={eventBucket.frontend_config.banner_image}
                style={{ width: "100%", marginBottom: 10 }}
              />
            )
          ) : (
            <RaisedButton
              style={{ verticalAlign: "top" }}
              primary={true}
              label="View native site"
              href={eventBucket.urls.root}
              target="_blank"
            />
          )}
          {eventBucket.enable_virtual_festival ? (
            <ViewLiveVirtualButton
              style={{ verticalAlign: "top", marginLeft: 7 }}
              primary={true}
              label="virtual catalog"
              href={eventBucket.urls.virtual_festival}
              target="_blank"
            />
          ) : null}
          {UserStore.hasPermission([
            "edit_event_bucket",
            "manage_configurator",
            "manage_embed_wizard"
          ]) ? (
            <RaisedButton
              style={{ marginLeft: 7 }}
              label="Settings"
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucket.id}/settings`
                )
              }
            />
          ) : null}
          {UserStore.hasPermission("view_analytics_list") ? (
            <RaisedButton
              style={{ marginLeft: 7 }}
              label="Analytics"
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucket.id}/analytics`
                )
              }
            />
          ) : null}
          {!(
            UserStore.hasRole("box_office") || UserStore.hasRole("film_preview")
          ) && (
            <TableRefreshIndicator
              onRefresh={() => this._refresh()}
              isRefreshing={
                this.props.isFetching || this.state.isFetchingEventBucket
              }
              style={{}}
            />
          )}
        </div>
        <div style={{ margin: "1em 0 2em" }}>
          <StatsBlockContainer>
            {UserStore.hasPermission("view_virtual_event_list") ||
            UserStore.hasPermission("box_office") ?
              eventBucket.enable_virtual_festival ? (
                <StatsBlock
                  value={eventBucket.virtual_events.length}
                  label="Virtual screenings"
                  onTouchTap={() =>
                    this.context.router.push(
                      `/event_buckets/${eventBucket.id}/virtual_festival`)
                  }
                />
                )
                :
                (
                  <StatsBlock
                    value={eventBucket.virtual_events.length}
                    label="Virtual screenings"
                  />
                )
              : null}
            {UserStore.hasPermission("view_physical_event_list") ? (
              <StatsBlock
                value={eventBucket.events.length}
                label="Physical events"
                onTouchTap={() =>
                  this.context.router.push(
                    `/event_buckets/${eventBucket.id}/events`
                  )
                }
              />
            ) : null}
            {UserStore.hasPermission("view_pass_bucket_list") ? (
              <StatsBlock
                value={eventBucket.pass_buckets.length}
                label="Pass buckets"
                onTouchTap={() =>
                  this.context.router.push(
                    `/event_buckets/${eventBucket.id}/pass_buckets`
                  )
                }
              />
            ) : null}
            {UserStore.hasPermission("manage_venues") ? (
              <StatsBlock
                value={eventBucket.venues.length}
                label="Venues"
                onTouchTap={() =>
                  this.context.router.push(
                    `/event_buckets/${eventBucket.id}/venues`
                  )
                }
              />
            ) : null}
          </StatsBlockContainer>
          <StatsBlockContainer>
            {UserStore.hasPermission("view_analytics") ? (
              <StatsBlock
                value={formatPrice(
                  overview ? overview.total_net_volume : 0,
                  ((UserStore.getUser() || {}).stripe_account_mode ===
                    "platform_managed" ||
                    ["krw", "clp"].includes(
                      (UserStore.getUser() || {}).currency
                    )) && {
                    currency: "usd"
                  }
                )}
                label="Net sales"
              />
            ) : null}
            {UserStore.hasPermission("view_analytics") &&
            (UserStore.hasPermission("manage_orders") ||
              UserStore.hasPermission("view_orders")) ? (
              <StatsBlock
                value={overview ? overview.total_paid_count : 0}
                label="Paid orders"
                onTouchTap={() =>
                  this.context.router.push(
                    `/event_buckets/${eventBucket.id}/orders`
                  )
                }
              />
            ) : null}
            {UserStore.hasPermission("manage_orders") ||
            UserStore.hasPermission("view_orders") ? (
              <StatsBlock
                value={overview ? overview.total_count : 0}
                label="Total orders"
                onTouchTap={() =>
                  this.context.router.push(
                    `/event_buckets/${eventBucket.id}/orders`
                  )
                }
              />
            ) : null}
          </StatsBlockContainer>
          {UserStore.hasRole("box_office") || UserStore.hasRole("manager") ? (
            <div
              style={
                UserStore.hasRole("manager")
                  ? null
                  : { maxWidth: 400, margin: "0 auto" }
              }
            >
              <StatsBlockContainer>
                {[
                  <StatsBlock
                    value={"Box Office"}
                    onTouchTap={() =>
                      this.context.router.push(
                        `/event_buckets/${eventBucket.id}/box_office`
                      )
                    }
                  />
                ]}
              </StatsBlockContainer>
              <StatsBlockContainer>
                {[
                  <StatsBlock
                    value={"People"}
                    onTouchTap={() =>
                      this.context.router.push(
                        `/event_buckets/${eventBucket.id}/people`
                      )
                    }
                  />
                ]}
              </StatsBlockContainer>
              <StatsBlockContainer>
                {[
                  <StatsBlock
                    value={"Orders"}
                    onTouchTap={() =>
                      this.context.router.push(
                        `/event_buckets/${eventBucket.id}/orders`
                      )
                    }
                  />
                ]}
              </StatsBlockContainer>
            </div>
          ) : null}
        </div>
        {overview && UserStore.hasPermission("view_analytics") ? (
          overview.total_paid_count ? (
            <div>
              <EventBucketSalesChart
                eventBucket={eventBucket.id}
                showAllTime={this.state.showAllTime}
              />
              <div style={{ marginTop: "1.5em", textAlign: "center" }}>
                <RaisedButton
                  label={
                    this.state.showAllTime
                      ? "Hide all time sales graphs"
                      : "Show all time sales graphs"
                  }
                  onTouchTap={() =>
                    this.setState({ showAllTime: !this.state.showAllTime })
                  }
                  labelStyle={{ color: "rgb(2, 136, 209)" }}
                />
              </div>
            </div>
          ) : (
            <Chart
              placeholder={`Detailed sales analytics will be available here as soon as the first ${eventBucket.name} item is sold!`}
            />
          )
        ) : null}
      </div>
    );
  }
}

export default connectToStores(EventBucket);



// WEBPACK FOOTER //
// ./src/app/components/event-bucket.jsx